export const projectData = [
    {
        id: 1,
        status: 'Finished',
        title: 'Logo Design',
        place: 'San Francisco, California',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.',
        stacks: '50',
        msg: '321',
        progress: '70',
        profilepic: ['/images/faces/face1.jpg', '/images/faces/face2.jpg', "/images/faces/face3.jpg"]

    },
    {
        id: 2,
        status: 'Finished',
        title: 'Branding Mockup',
        place: 'San Francisco, CA',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.',
        stacks: '45',
        msg: '123',
        progress: '70',
        profilepic: ['/images/faces/face1.jpg', '/images/faces/face2.jpg', "/images/faces/face3.jpg"]

    },
    {
        id: 3,
        status: 'On going',
        title: 'Mobile App Design',
        place: 'New York, USA',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.',
        stacks: '50',
        msg: '321',
        progress: '50',
        profilepic: ['/images/faces/face1.jpg', '/images/faces/face2.jpg', "/images/faces/face3.jpg"]

    },
    {
        id: 4,
        status: 'Finished',
        // mainImg: '/images/samples/300x300/1.jpg',
        mainImg: 1,
        title: 'Mobile App',
        place: 'Austin, Texas',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.',
        stacks: '50',
        msg: '321',
        progress: '70',
        profilepic: ['/images/faces/face1.jpg', '/images/faces/face2.jpg', "/images/faces/face3.jpg"]
    },
    {
        id: 5,
        status: 'Hold',
        // mainImg: '/images/samples/300x300/2.jpg',
        mainImg: 2,
        title: 'Dashboard Design',
        place: 'San Francisco, California',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.',
        stacks: '34',
        msg: '453',
        progress: '70',
        profilepic: ['/images/faces/face1.jpg', '/images/faces/face2.jpg', "/images/faces/face3.jpg"]

    },
    {
        id: 6,
        status: 'On going',
        // mainImg: '/images/samples/300x300/3.jpg',
        mainImg: 3,
        title: 'Ecommerce Website',
        place: 'Shoreditch, London',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.',
        stacks: '65',
        msg: '651',
        progress: '50',
        profilepic: ['/images/faces/face1.jpg', '/images/faces/face2.jpg', "/images/faces/face3.jpg"]

    },
    {
        id: 7,
        status: 'Hold',
        mainImg: 4,
        title: 'Logo Design',
        place: 'München, Germany',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.',
        stacks: '67',
        msg: '543',
        progress: '70',
        profilepic: ['/images/faces/face1.jpg', '/images/faces/face2.jpg', "/images/faces/face3.jpg"]

    },
    {
        id: 8,
        status: 'Finished',
        mainImg: 5,
        title: 'Branding Mockup',
        place: 'Russia, Moscow',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.',
        stacks: '67',
        msg: '543',
        progress: '25',
        profilepic: ['/images/faces/face1.jpg', '/images/faces/face2.jpg', "/images/faces/face3.jpg"]

    },
    {
        id: 9,
        status: 'On going',
        mainImg: 6,
        title: 'Mobile App Design',
        place: 'Odessa, Ukraine',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.',
        stacks: '87',
        msg: '558',
        progress: '22',
        profilepic: ['/images/faces/face1.jpg', '/images/faces/face2.jpg', "/images/faces/face3.jpg"]

    },
]